<script>
import includes from 'lodash/includes'
import map from 'lodash/map'
import find from 'lodash/find'
import get from 'lodash/get'
import Field from './../components/Field.vue'

import EventBus from './../eventBus.js'

export default {
  name: 'login',
  components: {},
  props: {
      defaultMsg: {
        type: String,
        required: false,
        default: '',
      },

      errorMsg: {
        type: String,
        required: false,
        default: {},
      },
  },
  data() {
    return {
      hasError: false,
      codeNo: '',
      password: '',
    }
  },
  mounted() {

  },
  computed: {
      getErrorMsg() {
          if (this.hasError) {
              if (this.codeNo === '') {
                  return this.errorMsg.split('|')[0];
              } else if (this.password === '') {
                  return this.errorMsg.split('|')[1];
              }
          } else if (this.defaultMsg !== '') {
              return this.defaultMsg;
          }
      },
  },
  methods: {
    onKeyup(e) {
        if (e.keyCode === 13) {
            if (this.codeNo !== '' && this.password != '') {
                this.submit();
            } else {
                this.hasError = true;
            }
        }
    },
    submit() {
        if (this.codeNo !== '' && this.password != '') {
            this.$refs.form.submit();
        } else {
            this.hasError = true;
        }
    },
  },
  watch: {

  }
}
</script>
